import { useTheme } from "@mui/material";
import { Cell, Legend, Pie, PieChart } from "recharts";
import Message from "../../../pages/components/message";
import { MessageSections } from "../../../pages/components/message/message";
import { PieContainer, TotalCardTitle } from "../styled";
import NoOrders from "../../../pages/orders/my/no-orders";
import { ChartData } from "../dashboard-page";

const RADIAN = Math.PI / 180;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
}: any) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.3;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  const value = (percent * 100).toFixed(0);
  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
    >
      {`${+value < 1 ? "<1" : value}%`}
    </text>
  );
};

const renderColorfulLegendText = (value: string) => {
  return <span style={{ color: "#2A2E3C", fontSize: "1rem" }}>{value}</span>;
};

const BarekamPie = ({ data, title }: BarekamPieProps) => {
  const theme = useTheme();

  return (
    <PieContainer>
      <TotalCardTitle>
        <Message messageKey={title} sectionId={MessageSections.ORDERS} />
      </TotalCardTitle>

      {data.length ? (
        <PieChart width={500} height={280}>
          <Legend
            iconSize={15}
            iconType={"circle"}
            formatter={renderColorfulLegendText}
            layout={"vertical"}
            align={"left"}
            verticalAlign={"top"}
            wrapperStyle={{ left: "3rem" }}
          />
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={renderCustomizedLabel}
            outerRadius={132}
            innerRadius={73}
            fill="#8884d8"
            dataKey="value"
            stroke="none"
            isAnimationActive={false}
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={theme.barekam.dashboard.barColors[index] || "#000"}
              />
            ))}
          </Pie>
        </PieChart>
      ) : (
        <NoOrders messageKey={"no_total_orders"} />
      )}
    </PieContainer>
  );
};

interface BarekamPieProps {
  data: ChartData[];
  title: string;
}

export default BarekamPie;
